import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@node_modules/@angular/common';
import { Router } from '@node_modules/@angular/router';
import { NgbActiveModal } from '@node_modules/@ng-bootstrap/ng-bootstrap';
import { AuthenticateResultModel } from '@shared/service-proxies/service-proxies';
import { LoginService } from 'account/login/login.service';
import { RegisterComponent } from 'account/register/register.component';

@Component({
  selector: 'app-webfacing-register',
  templateUrl: './webfacing-register.component.html',
  styleUrls: ['./webfacing-register.component.scss'],
  standalone: true,
  imports: [RegisterComponent, CommonModule]
})
export class WebfacingRegisterComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal, public loginService: LoginService, private router: Router) { }
  ngOnInit() {
    this.loginService.loginResult$.subscribe((result: AuthenticateResultModel) => {
      // this.activeModal.close(result);
    });
  }
}
